import { Link, useLocation } from 'react-router'

import { ArticleIcon } from '@pleio/icons/article'

import CoverImage from 'js/components/CoverImage'
import TiptapView from 'js/components/Tiptap/TiptapView'
import styles from 'js/magazine-issue/View/components/TableOfContents/TableOfContentsItem/TableOfContentsItem.module.css'
import type { MagazineIssueViewEntity } from 'js/magazine-issue/View/View.types'

type TableOfContentsItemProps = {
    url: string
    title: string
    abstract?: string
    icon?: React.ReactNode
    featured?: MagazineIssueViewEntity['articles'][number]['featured']
    direction: 'back' | 'forward'
}

const TableOfContentsItem = ({
    url,
    title,
    abstract,
    icon,
    featured,
    direction,
}: TableOfContentsItemProps) => {
    const location = useLocation()

    return (
        <Link
            className={styles.wrapper}
            to={url}
            state={{
                prevPathname: location.state?.prevPathname,
                direction,
            }}
        >
            {featured?.image || featured?.video ? (
                <CoverImage
                    featured={{
                        // Exclude caption
                        image: featured.image,
                        alt: featured.alt,
                        video: featured.video,
                        videoTitle: featured.videoTitle,
                        videoThumbnailUrl: featured.videoThumbnailUrl,
                    }}
                    size="cover"
                    videoButtonSize="small"
                    className={styles.tocItemFeatured}
                />
            ) : (
                <div className={styles.tocItemIcon}>
                    {icon || <ArticleIcon />}
                </div>
            )}

            <div className={styles.tocItemText}>
                <h2 className={styles.tocItemTitle}>{title}</h2>
                {abstract && <TiptapView content={abstract} textSize="small" />}
            </div>
        </Link>
    )
}

export default TableOfContentsItem
